import { StatsTealiumDataLayerEventActionEnum } from 'common/module/stats/tealium/data-layer/event-action.enum';
import { StatsTealiumDataLayerEventCategoryEnum } from 'common/module/stats/tealium/data-layer/event-category.enum';
import { StatsTealiumDataLayerEventReferenceEnum } from 'common/module/stats/tealium/data-layer/event-reference.enum';
import { StatsTealiumDataLayerTealiumEventEnum } from 'common/module/stats/tealium/data-layer/tealium-event.enum';
import { StatsTealiumProviderInterface } from 'common/module/stats/tealium/provider.interface';

export class SaveSearchTracker {
  /**
   * Constructor
   */
  constructor(private statsTealium: StatsTealiumProviderInterface) {}

  /**
   * Trigger on saved search cta clicked
   */
  public onClickCta(): void {
    this.statsTealium.setEventReference(StatsTealiumDataLayerEventReferenceEnum.SAVED_SEARCH);
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: 'click',
      tealium_event: 'save_search_click',
      event_label: '',
      sendToGa: true,
    });
  }

  /**
   * Triggered on email required screen is triggered from save search modal
   */
  public onCompleteProfileModalOpen(): void {
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: StatsTealiumDataLayerEventActionEnum.saveSearchEmailModalOpen,
      tealium_event: StatsTealiumDataLayerTealiumEventEnum.saveSearchEmailModalOpen,
      event_label: '',
      sendToGa: true,
    });
  }

  /**
   * Triggered on email required screen is submitted from save search modal
   */
  public onCompleteProfileModalSubmit(email: string): void {
    this.statsTealium.send({
      user_email: email,
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: StatsTealiumDataLayerEventActionEnum.saveSearchEmailSubmit,
      tealium_event: StatsTealiumDataLayerTealiumEventEnum.saveSearchEmailSubmit,
      event_label: '',
      sendToGa: true,
    });
  }

  /**
   * Triggered on email required screen is skipped from save search modal
   */
  public onCompleteProfileModalSkip(): void {
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: StatsTealiumDataLayerEventActionEnum.saveSearchAddEmailSkipped,
      tealium_event: StatsTealiumDataLayerTealiumEventEnum.saveSearchAddEmailSkipped,
      event_label: '',
      sendToGa: true,
    });
  }

  /**
   * Trigger when create dialog open
   */
  public onOpenCreateDialog(isEmailExists: boolean): void {
    this.statsTealium.send({
      event_action: StatsTealiumDataLayerEventActionEnum.createOpen,
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      tealium_event: StatsTealiumDataLayerTealiumEventEnum.saveSearchOpen,
      event_label: `notify_me_switched:${isEmailExists ? 'on' : 'off'}`,
      sendToGa: true,
    });
  }

  /**
   * Trigger when saved search created
   */
  public onCreateSuccess(locationIds: string[] = []): void {
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: StatsTealiumDataLayerEventActionEnum.saveSearchCreate,
      tealium_event: StatsTealiumDataLayerTealiumEventEnum.saveSearchCreate,
      event_label: locationIds.map((id) => `location:${id};`).join(''),
      sendToGa: true,
    });
  }

  /**
   * Trigger when user deleted the saved search
   */
  public onDeleteSuccess(saveSearchId: string): void {
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: 'card_delete',
      tealium_event: 'save_search_delete_card',
      event_label: saveSearchId,
      sendToGa: true,
    });
  }

  /**
   * Trigger when user successfully deleted all the saved searches
   */
  public onDeleteAllSuccess(): void {
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: 'card:deleteAll',
      tealium_event: 'save_search_delete_all',
      event_label: '',
      sendToGa: true,
    });
  }

  /**
   * Trigger when user open the dialog for editing
   */
  public onOpenEditDialog(): void {
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: 'card:edit:open',
      tealium_event: 'save_search_edit_open',
      event_label: '',
      sendToGa: true,
    });
  }

  /**
   * Trigger when editing is successfull
   */
  public onEditSuccess(saveSearchId: string): void {
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: 'card:edit:success',
      tealium_event: 'save_search_edit',
      event_label: saveSearchId,
      sendToGa: true,
    });
  }

  /**
   * Trigger when user click on the saved search card thats lead him/her to the serp page
   */
  public onClickCard(locationIds: string[] = []): void {
    this.statsTealium.send({
      event_category: StatsTealiumDataLayerEventCategoryEnum.saveSearch,
      event_action: 'card:click',
      tealium_event: 'save_search_serp_click',
      event_label: locationIds.map((id) => `|location:${id}|`).join(''),
      sendToGa: true,
    });
  }
}
